import {faTriangleExclamation} from '@fortawesome/pro-regular-svg-icons/faTriangleExclamation';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle} from '@mui/material';
import React from 'react';
import {useTranslation} from 'react-i18next';

interface UnsavedChangesModalProps {
  open: boolean;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}

export const UnsavedChangesModal: React.FC<UnsavedChangesModalProps> = ({open, message, onConfirm, onCancel}) => {
  const {t} = useTranslation();

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      aria-labelledby="unsaved-changes-dialog-title"
      aria-describedby="unsaved-changes-dialog-description"
    >
      <DialogTitle id="unsaved-changes-dialog-title" color="var(--palette-warning-dark)">
        <FontAwesomeIcon icon={faTriangleExclamation} /> {t('warnWhenUnsavedChanges.title')}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="unsaved-changes-dialog-description">{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>{t('buttons.stay')}</Button>
        <Button onClick={onConfirm} variant="soft" color="warning" autoFocus>
          {t('buttons.leave')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
